<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<h1 class="center">Just Over the Horizon</h1>
<h3 class="center" style="margin-top:40px;">The Complete Short Fiction of</h3>
<h2 class="center" style="margin-top:20px;">Greg Bear</h2>
<h3 class="center" style="margin-top:40px;">Volume One</h3>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// JustOvertheHorizon_1P.vue?3105ec1c